export const FAQS = [
  {
    question: 'How does an order work? || Hur fungerar en order?',
    answer:
      'Each order is a conversation with the Klayder team, like writing by email. The brief, products, mockups and status stay in one thread, and a person at Klayder reviews the quote before you approve. || Varje order är en konversation med Klayder-teamet, som att skriva mejl. Brief, produkter, mockups och status stannar i en tråd, och en person på Klayder granskar offerten innan ni godkänner.',
  },
  {
    question: 'Who is this for? || Vem är det här för?',
    answer:
      'Companies of 50+ people placing merch orders that have to be right: onboarding kits, events, culture merch, size runs. || Bolag med 50+ medarbetare som lägger merchordrar som måste bli rätt: onboardingkit, event, kulturmerch, storleksserier.',
  },
  {
    question: 'Do I have to use Sara? || Måste jag använda Sara?',
    answer:
      'No. You can brief the team and never use the agent, use Sara only when it helps, or complete the quote with Sara. Same workspace either way. || Nej. Ni kan briefa teamet och aldrig använda agenten, använda Sara bara när det hjälper, eller göra klart offerten med Sara. Samma arbetsyta oavsett.',
  },
  {
    question:
      'Does a person review my order if I use Sara? || Granskar en person min order om jag använder Sara?',
    answer:
      'Yes. A person at Klayder reviews every quote (sizes, decorations, and delivery) before you can approve. Sara is optional. Humans are not. || Ja. En person på Klayder granskar varje offert (storlekar, tryck och leverans) innan ni kan godkänna. Sara är valfri. Människor är det inte.',
  },
  {
    question:
      'What is the minimum order quantity? || Vad är minsta ordersantal?',
    answer:
      'Minimum varies by product and often starts at 25 units. Most customers are 50+ employee teams ordering at company scale. Contact us for a specific product. || Minimiantal varierar per produkt och börjar ofta på 25 enheter. De flesta kunderna är bolag med 50+ medarbetare som beställer i bolagsskala. Kontakta oss för en specifik produkt.',
  },
  {
    question:
      'How long does production and delivery take? || Hur lång tid tar produktion och leverans?',
    answer:
      'Standard production takes 2-3 weeks from design approval. Rush orders can be completed in 5-7 business days, depending on the product. Delivery time depends on your location but typically adds 3-5 business days. || Standardproduktion tar 2-3 veckor från designgodkännande. Expressordrar kan slutföras på 5-7 arbetsdagar, beroende på produkt. Leveranstid beror på din plats men lägger vanligtvis till 3-5 arbetsdagar.',
  },
  {
    question:
      'Can I see samples before placing a large order? || Kan jag se prover innan jag lägger en stor order?',
    answer:
      'Yes. We offer free samples so you can check quality, fit and print before a large order. Ask the Klayder team and we will send them. || Ja. Vi erbjuder gratisprover så att ni kan kolla kvalitet, passform och tryck innan en stor order. Hör av er till Klayder-teamet så skickar vi dem.',
  },
  {
    question:
      'What file formats do you accept for logos and designs? || Vilka filformat accepterar ni för logotyper och design?',
    answer:
      'We accept vector files (AI, EPS, PDF, SVG) for best results. High-resolution PNG or JPG files (300 DPI minimum) also work well. Our design team can help convert or recreate artwork if needed. || Vi accepterar vektorfiler (AI, EPS, PDF, SVG) för bästa resultat. Högupplösta PNG- eller JPG-filer (minst 300 DPI) fungerar också bra. Vårt designteam kan hjälpa till att konvertera eller återskapa grafik vid behov.',
  },
  {
    question:
      'Do you offer warehousing and fulfillment services? || Erbjuder ni lagerhållning och fulfillment-tjänster?',
    answer:
      "Yes, we offer inventory storage and on-demand fulfillment. Store your merch with us and we'll ship individual orders to employees, customers, or event attendees as needed. || Ja, vi erbjuder lagerförvaring och fulfillment på begäran. Lagra din merch hos oss så skickar vi individuella ordrar till anställda, kunder eller eventdeltagare efter behov.",
  },
  {
    question:
      "What happens if I'm not satisfied with my order? || Vad händer om jag inte är nöjd med min order?",
    answer:
      "We stand behind our quality. If there are any defects or issues with your order, and it's not within the factory's margin of error, we'll refund at no additional cost. We also offer pre-production mockups and samples to ensure satisfaction. || Vi står bakom vår kvalitet. Om det finns några defekter eller problem med din order, och det inte är inom fabrikens felmarginal, återbetalar vi utan extra kostnad. Vi erbjuder också förproduktionsmockups och prover för att säkerställa nöjdhet.",
  },
  {
    question:
      'Can I put our logo on all products? || Kan jag sätta vår logotyp på alla produkter?',
    answer:
      'Yes, you can put your logo on all products. We offer a wide range of products and colors, so you can find the perfect one for your brand. || Ja, du kan sätta din logotyp på alla produkter. Vi erbjuder ett brett utbud av produkter och färger, så att du kan hitta den perfekta för ditt varumärke.',
  },
] as const
